// extracted by mini-css-extract-plugin
export default {"navItem":"MobileNavbar_navItem__AHTsu","icon":"MobileNavbar_icon__mO4VF","iconBtnDiv":"MobileNavbar_iconBtnDiv__ZvmMY","iconBtnDivActive":"MobileNavbar_iconBtnDivActive__xcYvZ"};